import { Injectable } from '@angular/core';
import { EmailGroup } from '../../model/admin/email-group';
import { EmailGroupMember } from '../../model/admin/email-group-member';
import { LazyLoadEvent } from '@openng/optimus-ui/api';
import { BaseTableService } from './base-table.service';

@Injectable({
  providedIn: 'root',
})
export class EmailGroupTableService extends BaseTableService<EmailGroup> {
  private members: EmailGroupMember[] = [];

  constructor() {
    super();
  }

  getEmailGroupMembers(): EmailGroupMember[] {
    return this.members;
  }

  setEmailGroupMembers(members: EmailGroupMember[]): void {
    this.members = members;
  }
}
